import React, { useCallback } from "react";
import { Button } from "..";
import { downloadStringAsPDF } from "../../../lib/functions";

interface DownloadPDFButtonProps {
  data?: string;
  title: string;
  disabled: boolean;
  isLoading: boolean;
  setIsDownloading: React.Dispatch<React.SetStateAction<boolean>>;
}

const DownloadPDFButton = ({
  data,
  title,
  disabled,
  isLoading,
  setIsDownloading,
}: DownloadPDFButtonProps) => {
  const handleDownload = useCallback(() => {
    if (!data) return;

    setIsDownloading(true);

    setTimeout(() => {
      const content = data;
      const fileName = "api-logs.pdf";

      downloadStringAsPDF(content, fileName);
      setIsDownloading(false);
    }, 100);
  }, [data, setIsDownloading]);

  return (
    <Button
      type="button"
      disabled={disabled}
      isLoading={isLoading}
      onClick={handleDownload}
    >
      {title}
    </Button>
  );
};

export default React.memo(DownloadPDFButton);
